import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-mlp-customer-service-box',
  templateUrl: './mlp-customer-service-box.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MlpCustomerServiceBoxComponent {}
